"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var financeSummaryBlocksStaticContentStyles_1 = require("./financeSummaryBlocksStaticContentStyles");
var SummaryBlockStaticContent = function (_a) {
    var showTitle = _a.showTitle, isError = _a.isError, children = _a.children;
    var style = financeSummaryBlocksStaticContentStyles_1.default();
    return (<>
      {showTitle && (<core_1.Typography variant="subtitle1" className={style.emphasizedText} data-test="finance_summary:text:title">
          <Translation_1.default id={'financeSummary.header.personalisedFinanceQuote'}/>
        </core_1.Typography>)}
      {isError && (<core_1.Typography variant="subtitle1" className={style.emphasizedText} data-test="finance_summary:text:sub_title">
          <Translation_1.default id={'financeSummary.text.error'}/>
        </core_1.Typography>)}
      {children}
    </>);
};
exports.default = SummaryBlockStaticContent;
